import classNames from 'classnames'
import { jsonConvert } from '../../../../helpers/jsonConvert'
import { AnswerButton } from '../AnswerButton/AnswerButton'
import { useTaskHomeWork } from '../hooks/useTaskHomeWork'
import s from './Multi.module.css'
import { formateTime } from '@/helpers/formateTime'
import { useState } from 'react'
import { Tooltip } from 'antd'
import Constructor from '@UI/New/Constructor'
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet'
import { VideoAnswer } from '../VideoAnswer/VideoAnswer'
import { useVideoState } from '../hooks/useVideoState'

export const Multi = ({ type, ...props }) => {
  switch (type) {
    case 'decided': return <Decided {...props} />
    case 'correction': return <Correction {...props} />
    default: return <Task type={type} hist={props?.hist}  {...props} />
  }
}

const Correction = (props) => {
  
  if(props?.correct_answer[0]?.type === 'constructor'){
    return  <Constructor 
              className={s.constructor}
              value={[]}
              prohibitEditing
            />
  }
  return <input className={classNames(s.input, s.inputCorrection)} placeholder='Напишите ответ' disabled={true} />
}

const Decided = ({ userRole, ...props }) => {
  const { video, videoType } = useVideoState(
          {
              video_source_type: props?.params?.result?.video_source_type,
              video_solution: props?.params?.result?.video_solution,
              video_solution_platform_media: props?.params?.result?.video_solution_platform_media,
              video_solution_iframe: props?.params?.result?.video_solution_iframe
          }
  );

  const answer = jsonConvert(props?.params?.result?.answer, 'json')
  const correctAnswer = jsonConvert(props.params?.result?.correct_answer, 'json')
  const decidedRight = props?.params?.result?.decided_right

  return <>
    <div className={s.answerWrap}>
            <span className={classNames(s.capsuleLeft, { [s.red]: (!decidedRight && !props?.hideSolutionCorrectness) })}>{userRole === 'children' ? 'Ваш ответ' : 'Ответ ребёнка'}</span>
            <div>
                {
                  answer?.type === 'constructor' && <Constructor className={s.constructor} value={(answer.value && Array.isArray(answer.value)) ? answer.value : []} prohibitEditing />
                }
                {
                  answer?.type !== 'constructor' && (
                    <span className={s.capsuleRight}>
                      {String(answer)?.length > 0 ? answer : <span className='error'>Нет ответа</span>}
                    </span>
                  )
                }

            </div>   

    {correctAnswer && !props?.hideSolutionCorrectness && (
        <>
          {Array.isArray(correctAnswer) ? (
            <span className={s.capsuleLeft}>Правильным ответом является любой из списка:</span>
          ) : (<span className={s.capsuleLeft}>Правильный ответ</span>)}

          {Array.isArray(correctAnswer) && correctAnswer?.map((el, i) => {
            return (
              <>
                {
                  el.type === 'constructor' && <div style={{display: 'flex', gap: '5px'}}>
                    {i + 1})
                    <Constructor 
                      className={s.constructor}
                      value={(el.text && Array.isArray(el.text)) ? el.text : []}
                      prohibitEditing
                    />
                  </div>
                }
                {
                  el.type !== 'constructor' && <span style={{display: 'flex', gap: '5px'}}>{i + 1}) <span key={i} className={s.capsuleRight}>{el.text}</span></span>
                }
              </>
            )
          })}

          {
            (typeof correctAnswer === 'string' || typeof correctAnswer === 'number') && (
              <div><span className={s.capsuleRight}>{correctAnswer}</span></div>
            )
          }
        </>
      )
    }
      
  </div>
    {props?.params?.result?.time_spent &&
      <div className={s.estimation}>
        <span className={s.booble}>Потрачено время</span>
        <span className={s.booble}> {formateTime(props?.params?.result?.time_spent)}</span>
      </div>
    }
    {video && <div style={{marginTop: '10px'}}><VideoAnswer video={video} videoType={videoType} /></div>}
  </>
}

const Task = ({ hist, params, type, userRole, ...props }) => {
  const { onAnswer, answer, status, hint, video, videoType, correctAnswer } = useTaskHomeWork(params,
      {
        ...props, 
        type: (type === 'exact-answer' && props?.correct_answer[0]?.type === 'constructor') ? 'constructor': 'text'})
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [constructor, setConstructor] = useState(answer.get?.type === 'constructor');
  const constructorToggle = () => {
    if(status > 4 || userRole === 'parent') return;
    setConstructor((value) => {
      if(value) {
        answer.set('');
      }
      else{
        answer.set({type: 'constructor', value: []});
      }
      return !value;
    })
  }
  const handleInputChange = (e) => {
    let value = e.target.value;
    let isInvalid = false;

    // Заменяем все запятые на точки
    // value = value.replace(/,/g, '.');

    if (type === 'exact-answer' && props.is_number_answer) {
      const originalValue = value;

      if (value === "") {
        isInvalid = true;
      } 
      else if (/^[.,]/.test(value)) { // Запрет точек/запятых в начале
        isInvalid = true;
      } 
      else if ((value.match(/\./g) || []).length > 1 ||  // Несколько точек
              (value.match(/,/g) || []).length > 1) {   // Или запятых
        isInvalid = true;
      } 
      else if (!/^-?\d*([.,]?\d+)?$/.test(value)) { // Общая проверка на число
        isInvalid = true;
      }

      if (originalValue !== value) {
        isInvalid = true;
      }
    }

    setTooltipVisible(isInvalid);
    answer.set(value);
  };

  const handleConstructorChange = (value) => {
    answer.set(value);
  }
  
  return <form onSubmit={onAnswer.handler}>
    <Tooltip
      title="В это поле нужно ввести число"
      open={tooltipVisible}
      placement="top"
    ></Tooltip>

    {
      constructor && <Constructor className={classNames(s.constructor, s.mt20)} prohibitEditing={status > 4 || userRole === 'parent'} edit={(value) => handleConstructorChange({type:'constructor', value})} value={answer.get.value} />
    }
    
    {
      !constructor && <input className={s.input} value={answer.get} onChange={handleInputChange} placeholder='Напишите ответ' disabled={status > 4 || userRole === 'parent'} />
    }
  
    {/* <CheckboxViolet
        className={s.checkbox}
        value={constructor}
        onClick={constructorToggle}
        text='Конструктор ответа'
    /> */}

    {correctAnswer && hist !== '?redo=ok' && params.type !== 'control' && !props?.hideSolutionCorrectness && <div className={s.answerWrapTask}>
      {Array.isArray(correctAnswer) ? (
        <span className={s.capsuleLeft}>Правильным ответом является любой из списка:</span>
      ) : (<span className={s.capsuleLeft}>Правильный ответ</span>)}
      
      {!props?.hideSolutionCorrectness && Array.isArray(correctAnswer) && correctAnswer?.map((el, i) => {
        return (
          <>
            {
              el.type === 'constructor' && <div style={{display: 'flex', gap: '5px'}}>
                {i + 1})
                <Constructor 
                  value={(el.text && Array.isArray(el.text)) ? el.text : []}
                  prohibitEditing
                  className={s.constructor}
                />
              </div>
            }
            {
              el.type !== 'constructor' && <span style={{display: 'flex', gap: '5px'}}>{i + 1}) <span key={i} className={s.capsuleRight}>{el.text}</span></span>
            }
          </>
        )
      })}
      {
        !props?.hideSolutionCorrectness && (typeof correctAnswer === 'string' || typeof correctAnswer === 'number') && (
          <div><span className={s.capsuleRight}>{correctAnswer}</span></div>
        )
      }
    </div>}

    <AnswerButton hideSolutionCorrectness = {props?.hideSolutionCorrectness} hintForChild={params.hintForChild} hintAfterAllAttempts={props.hint_after_all_attempts} {...{ status, onAnswer, hint, video, videoType }} />
  </form>
}
